import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

interface DimensionItem {
  iconType: 'clipboard' | 'messages' | 'file' | 'send' | 'target' | 'route';
  title: string;
  description: string;
  analyzedVia: string;
}

@Component({
  selector: 'app-dimension-grid',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './dimension-grid.component.html',
  styleUrl: './dimension-grid.component.scss'
})
export class DimensionGridComponent {
  dimensions: DimensionItem[] = [
    {
      iconType: 'clipboard',
      title: 'Assessment Performance',
      description: 'Consistency and clearance in technical/aptitude tests.',
      analyzedVia: 'Clearance rate'
    },
    {
      iconType: 'messages',
      title: 'Interview Performance',
      description: 'Success rate in mock and real interview scenarios.',
      analyzedVia: 'Conversion rate'
    },
    {
      iconType: 'file',
      title: 'Profile / Resume Readiness',
      description: 'Completeness of academic and portfolio data.',
      analyzedVia: 'Profile strength'
    },
    {
      iconType: 'send',
      title: 'Application Activity',
      description: 'Volume and pacing of active job applications.',
      analyzedVia: 'Application count'
    },
    {
      iconType: 'target',
      title: 'Skill / Job Alignment',
      description: 'Alignment of demonstrated skills to role requirements.',
      analyzedVia: 'Match percentage'
    },
    {
      iconType: 'route',
      title: 'Placement Progress',
      description: 'Progression through the placement funnel.',
      analyzedVia: 'Current stage'
    }
  ];
}
